import { apiSlice } from "../apiSlice";

export const bulkDealSparesPriorityApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBulkSparesPriority: builder.query({
      query: () => "bulk_deals/spares/priority",

      transformResponse: (response) => ({
        seller: response?.data?.seller ?? "",
        lotId: response?.data?.lot_id ?? "",
      }),
    }),
  }),
  overrideExisting: false,
});

/* ✅ Correct hook export */
export const {
  useGetBulkSparesPriorityQuery,
} = bulkDealSparesPriorityApi;